import React, { useContext, useState } from "react";
import { Form } from "react-jsonschema-form-validation";
import { resetUserSettings } from "../../../services/userService";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { setupData } from "../../../configs/routes";
import { pathRoot, getMultiSelectElements } from "../BenefitStatus";
import { DiseaseGroupContext } from "../../../contexts/diseaseGroupContext";

export function Page1({ benefitStatus }) {
	const schema = {
		type: "object",
	};

	const optionsData = [
		{
			label: "Benefits Advisor",
			value: 7,
		},
		{
			label: "Social Worker",
			value: 8,
		},
		{
			label: "Macmillan Nurse",
			value: 0,
		},
		{
			label: "Clinical Nurse Specialist",
			value: 1,
		},
		{
			label: "General Practitioner (GP)",
			value: 2,
		},
		{
			label: "Citizens Advice Bureau (CAB)",
			value: 3,
		},
		{
			label: "On-line Search (e.g. Google)",
			value: 4,
		},
		{
			label: "Support Group",
			value: 5,
		},
		{
			label: "No advice needed",
			value: 6,
		},
		{
			label: "I have not received any benefits advice",
			value: 99,
		},
	];

	const [benefitAdvice, setBenefitAdvice] = useState(
		benefitStatus.benefitAdvice ?? []
	);

	const toggleBenefitAdvice = (value) => {
		if (isChecked(value)) {
			setBenefitAdvice(
				benefitAdvice.filter((e) => {
					return e !== value;
				})
			);
		} else {
			const temp =
				value === 6 || value === 99
					? []
					: benefitAdvice.filter((e) => {
							return (e !== 6) & (e !== 99);
					  });
			temp.push(value);
			setBenefitAdvice(temp);
		}
	};

	const updateUserSettings = () => {
		benefitStatus.benefitAdvice = benefitAdvice;
	};

	const isChecked = (value) => {
		return benefitAdvice.some((e) => e === value);
	};

	const headerDetails = {
		title: "Benefit Status",
		currentPage: 1,
		pageCount: 2,
	};

	const { theme } = useContext(DiseaseGroupContext);

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={setupData}
				nextTo={`${pathRoot}/2`}
				onClickBack={resetUserSettings}
				onClickNext={updateUserSettings}
				hideNext={benefitAdvice.length === 0}
			>
				<Form schema={schema}>
					<p className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						Who have you received advice from about your benefits?
					</p>
					<p className={"mb-6"}>(select all that apply)</p>
					<div>
						{getMultiSelectElements(
							optionsData,
							"benefitAdvice",
							benefitAdvice,
							toggleBenefitAdvice,
							isChecked,
							theme
						)}
					</div>
				</Form>
			</SetupDataPageTemplate>
		</>
	);
}
